import { GroupMessageSmsSearchFilter } from 'src/modules/groupMessageEmail/models/groupMessageSmsSearchFilter';
import { GroupMessageSmsResponse } from 'src/modules/groupMessageEmail/models/groupMessageSmsRespons';
import AxiosInstance from 'src/shared/services/axios/interceptor';
import { GroupMessageSmsRequest } from 'src/modules/groupMessageEmail/models/groupMessageSmsRequest';
import { GroupMessageSmsRequestPut } from 'src/modules/groupMessageEmail/models/groupMessageSmsRequestPut';
import { PagedResult } from '../models/pagedResult';

const controller = 'GroupMessageSms';

export const getAll = (searchFilter: GroupMessageSmsSearchFilter) => {
  return AxiosInstance.get<PagedResult<GroupMessageSmsResponse>>(controller, { params: searchFilter });
};

export const updateGroupMessageSms = (data: GroupMessageSmsRequestPut) => {
  return AxiosInstance.put(controller, data);
};

export const getGroupMessageSmsById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<GroupMessageSmsResponse>(endpoint);
};

export const createSms = (data: GroupMessageSmsRequest) => {
  return AxiosInstance.post(controller, data);
};
